import React from 'react';

const CTA = () => {
  return (
    <div className='cta'>
      <a href="https://drive.google.com/file/d/1RiXsckeGDpY4qx4_ZDiie2ztXr8_Kg7u/view?usp=sharing" download className='btn'>Download CV</a>
      <a href="#contact" className='btn btn-primary'>Let's Talk</a>
    </div>
  )
}

export default CTA